import { createAction, props } from '@ngrx/store';

export const addDate = createAction('[MULTIPLE ORDERS] [SCHEDULE DATES] Add Date', props<{ timestamp: number }>());

export const addForm = createAction('[MULTIPLE ORDERS] [SCHEDULE DATES] Add Form');

export const deleteForm = createAction('[MULTIPLE ORDERS] [ORDERS DATES] Delete Form');

export const resetScheduleDate = createAction('[MULTIPLE ORDERS] [ORDERS DATES] Reset Schedule Date');

export const ScheduleDatesActions = {
  addDate,
  addForm,
  deleteForm,
  resetScheduleDate,
};

export default ScheduleDatesActions;
